import { cva } from 'class-variance-authority'

export const badgeVariants = cva(
  'inline-flex items-center justify-center border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',
        overlay: 'bg-card/95 text-foreground shadow-sm',
      },
      size: {
        xs: 'rounded px-2 py-0.5 text-xs',
        sm: 'rounded-md px-2 py-0.5 text-xs',
        default: 'rounded-md px-2.5 py-0.5 text-xs',
        lg: 'rounded-md px-3 py-1 text-sm',
      },
      shape: {
        default: '',
        pill: 'rounded-full',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      shape: 'default',
    },
  }
)
